<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocf"><a class="xref" href="#/barretthedefiant0007#prog">Prologue: Wisconsin, 2011</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0008#intro">Introduction: The American Protest Tradition</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0009#ch01">1 The Forests for the Trees: Neoliberalism and the Environment</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0010#ch02">2 Rebel Spaces: Youth, Art, and Countercultures</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0011#ch03">3 Links in the Chain: Workers’ Rights Networks and Globalization</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0012#ch04">4 Invasion and Occupation: Fighting the “War on Terror”</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0013#ch05">5 Eviction and Occupation: Austerity and the Global Recession</a></p>
<p class="toc"><a class="xref" href="#/barretthedefiant0014#epil">Epilogue: Kennedy International Airport, 2017</a></p>
<p class="tocbmf"><a class="xref" href="#/barretthedefiant0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/barretthedefiant0016#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/barretthedefiant0017#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/barretthedefiant0018#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/barretthedefiant0019#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// barretthedefiant-0006.vue?67f9e61f